var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "discount-page" }, [
      _c("h2", { staticClass: "discount-page__title" }, [_vm._v("Скидки")]),
      _vm._v(" "),
      _c("div", { staticClass: "discount-page__content" }, [
        _c("div", { staticClass: "static-sale-item" }, [
          _c("div", { staticClass: "static-sale-item__num" }, [
            _vm._v("\n            от 3%\n         "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "static-sale-item__main" }, [
            _c("div", { staticClass: "static-sale-item__title" }, [
              _c("h3", [_vm._v("Групповая скидка")]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "static-sale-item__content" }, [
              _c("p", [
                _vm._v(
                  "\n               Для групп от 15-и человек. Процент скидки рассчитывается индивидуально и зависит от даты круиза и количества человек в группе.\n               "
                ),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "tags__item tags__item--lvl" }, [
                _vm._v(
                  "ДАННАЯ СКИДКА НЕ ПРЕДОСТАВЛЯЕТСЯ ВМЕСТЕ С ДРУГИМИ ВИДАМИ СКИДОК"
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n                  Цены для групп предоставляются по запросу и могут отличаться от цен, указанных на сайте.\n               "
                ),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "section-title" }, [
          _vm._v("\n         Скидки для отдельных категорий граждан\n      "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "static-sale-item" }, [
          _c("div", { staticClass: "static-sale-item__num" }, [
            _vm._v("\n            8%\n         "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "static-sale-item__main" }, [
            _c("div", { staticClass: "static-sale-item__title" }, [
              _c("h3", [_vm._v("Скидка сотрудникам силовых ведомств")]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "static-sale-item__content" }, [
              _c("p", [
                _vm._v(
                  "\n                  Данная скидка предоставляется действующим сотрудникам силовых ведомств, в том числе членам их семей (Министерство внутренних дел, Федеральная служба безопасности, Министерство обороны, Следственный комитет, Федеральная служба охраны, Министерство по делам гражданской обороны, чрезвычайным ситуациям и ликвидации последствий стихийных бедствий (МЧС), Генеральная прокуратура, Федеральная служба войск национальной гвардии, Служба внешней разведки, Государственная фельдъегерская служба, Главное управление специальных программ, Министерство юстиции, Федеральная таможенная служба, Федеральная служба судебных приставов (органы принудительного исполнения), Федеральная служба исполнения наказаний (ФСИН России)), а также ветеранам ВОВ, участникам боевых действий и членам их семей. Скидка предоставляется при условии единовременного оформления заказа на рейс, при этом сотрудник силовых ведомств, ветеран ВОВ или участник боевых действий должен входить в состав туристов. Сотрудникам вышеперечисленных ведомств скидка предоставляется на основании заявления и предъявления служебного удостоверения или предоставления справки с места работы. Участникам боевых действий скидка предоставляется на основании заявления и предъявления удостоверения участника боевых действий или свидетельства о праве на льготы, выданного военкоматом, а ветеранам ВОВ – при предъявлении удостоверения.\n               "
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n                  Данная скидка не предоставляется вместе с другими видами скидок, а также не распространяется на круизы на т/х «Нижний Новгород».\n               "
                ),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "tags__item tags__item--lvl" }, [
                _vm._v("ПРЕДОСТАВЛЯЕТСЯ ЧАСТНЫМ ЛИЦАМ И АГЕНТСТВАМ"),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "static-sale-item" }, [
          _c("div", { staticClass: "static-sale-item__num" }, [
            _vm._v("\n            8%\n         "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "static-sale-item__main" }, [
            _c("div", { staticClass: "static-sale-item__title" }, [
              _c("h3", [_vm._v("Скидка многодетным семьям")]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "static-sale-item__content" }, [
              _c("p", [
                _vm._v(
                  "\n                  Скидка предоставляется многодетным семьям, а также их сопровождающим, при условии единовременного оформления заказа на рейс. При этом член многодетной семьи должен входить в состав группы туристов. В случае, если представитель многодетной семьи отказывается от тура, скидка аннулируется и для сопровождающих. Скидка применяется ко всем действующим тарифам. Для получения скидки нужно предъявить удостоверение многодетной семьи РФ.\n               "
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n                  Данная скидка не предоставляется вместе с другими видами скидок, а также не распространяется на круизы на т/х «Нижний Новгород».\n               "
                ),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "tags__item tags__item--lvl" }, [
                _vm._v("ПРЕДОСТАВЛЯЕТСЯ ЧАСТНЫМ ЛИЦАМ И АГЕНТСТВАМ"),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "static-sale-item" }, [
          _c("div", { staticClass: "static-sale-item__num" }, [
            _vm._v("\n            8%\n         "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "static-sale-item__main" }, [
            _c("div", { staticClass: "static-sale-item__title" }, [
              _c("h3", [_vm._v("Скидка молодоженам")]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "static-sale-item__content" }, [
              _c("p", [
                _vm._v(
                  "\n                  Скидка предоставляется молодоженам, а также их друзьям и родственникам, на рейсы с отправлением в течение одного календарного года со дня заключения брака. При отказе молодоженов от тура скидка аннулируется и для сопровождающих. Для получения скидки нужно предъявить справку о подаче заявления в органы ЗАГС или оригинал/копию свидетельства о заключении брака.\n               "
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n                  Данная скидка не предоставляется вместе с другими видами скидок, а также не распространяется на круизы на т/х «Нижний Новгород».\n               "
                ),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "tags__item tags__item--lvl" }, [
                _vm._v("ПРЕДОСТАВЛЯЕТСЯ ЧАСТНЫМ ЛИЦАМ И АГЕНТСТВАМ"),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "static-sale-item" }, [
          _c("div", { staticClass: "static-sale-item__num" }, [
            _vm._v("\n            8%\n         "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "static-sale-item__main" }, [
            _c("div", { staticClass: "static-sale-item__title" }, [
              _c("h3", [_vm._v("Скидка медицинским работникам")]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "static-sale-item__content" }, [
              _c("p", [
                _c("strong", [_vm._v("Специальная скидка 8%")]),
                _vm._v(
                  " предоставляется медицинскому работнику и сопровождающему лицу, следующему вместе с ним в одной каюте, в рамках одного заказа.\n               "
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n                  Скидка применяется ко всем действующим тарифам. Данная скидка не предоставляется вместе с другими видами скидок, а также не распространяется на круизы на т/х «Нижний Новгород».\n               "
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "\n                  Для получения скидки необходимо предоставить справку с места работы с указанием медицинского учреждения и должности медицинского работника (согласно номенклатуре должностей, утвержденной Приказом Минздрава России №205 от 02.05.2023г., сроком его действия с 01.09.2023г. (вступил в силу) и по 01.09.2025г.) "
                ),
                _c("br"),
                _vm._v("\n                  Медицинские работники:"),
                _c("br"),
                _vm._v("\n                  - Руководители*;"),
                _c("br"),
                _vm._v(
                  "\n                  - Специалисты с высшим профессиональным (медицинским) образованием (врачи);"
                ),
                _c("br"),
                _vm._v(
                  "\n                  - Специалистов со средним профессиональным (медицинским) образованием (средний медицинский персонал);"
                ),
                _c("br"),
                _vm._v(
                  "\n                  - Медицинские работники (младший медицинский персонал)."
                ),
                _c("br"),
                _vm._v(
                  "\n                  *при условии, если в их трудовые (должностные) обязанности входит осуществление медицинской деятельности.\n               "
                ),
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  " Список должностей Приказа №205 от 02.05.2023г., для которых не предусмотрена скидка медицинского работника, пункты: "
                ),
                _c("br"),
                _vm._v(
                  "\n                  п.1.6.;  раздел 2. пп. 2.1.; 2.2.; 2.3.; 2.4.; раздел 4. пп 4.1.; 4.2.; 4.3.; раздел 7. пп 7.1.; 7.2.; 7.3. раздел 8. пп 8.1.; 8.2.; пп 12.3.; 12.4.; 13. \n               "
                ),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "tags__item tags__item--lvl" }, [
                _vm._v("ПРЕДОСТАВЛЯЕТСЯ ЧАСТНЫМ ЛИЦАМ И АГЕНТСТВАМ"),
              ]),
            ]),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }